<template>
  <div>
    <div class="m-2">
      {{ $lang.definition_competence }} : {{ competency_description }}
    </div>
    <div class="table-responsive">
      <LoadingSpinner :loading="isOverlay" />
      <div v-if="!isOverlay">
        <b-table
          v-if="indicators.length"
          :items="indicators"
          :fields="fields"
          striped
          responsive="sm"
          :busy="radiosTableLoading"
        >
          <template #table-busy>
            <LoadingSpinner :loading="true" :text="$lang.updating_data" />
          </template>
          <template v-slot:cell(exercise)="row">
            <b-button
              size="sm"
              variant="primary"
              @click="showIndicatorEvidence(row)"
              class="mr-2 position-relative"
            >
              <span
                v-if="row.item.evidence_count"
                class="badge badge-danger text-white bade-main"
                v-text="row.item.evidence_count"
              />
              <i
                v-if="row.detailsShowing"
                class="fa fa-chevron-up"
                aria-hidden="true"
              />
              <i v-else class="fa fa-chevron-down" aria-hidden="true"></i>
            </b-button>
          </template>
          <template v-slot:cell(id)="row">
            <div class="d-flex align-items-center justify-content-between">
              <span
                class="text-danger"
                v-if="pathOr(false, ['item', 'has_evidence_error'], row)"
                v-b-tooltip.hover
                :title="'در مصادیق این نشانگر خطایی ثبت شده است'"
              >
                <mdicon name="alert" size="20" />
              </span>
            </div>
          </template>
          <template v-slot:cell(indicator)="row">
            <div class="d-flex align-items-center justify-content-start">
              <i
                class="fa fa-plus text-success"
                v-if="
                  row.item.indicator_value &&
                  row.item.indicator_value_object.id == 1
                "
              />
              <i class="fas fa-minus text-danger" v-else />
              <span
                class="ml-2"
                v-text="
                  `${row.item.indicator} ${generateIndicatorCode(row.item)}`
                "
              />
            </div>
          </template>
          <template v-slot:cell(status)="row">
            <b-radio
              v-model="row.item.status_object.id"
              value="-1"
              @change.native="changeStatus(row.item)"
              :disabled="!isScoreEditable"
            />
          </template>
          <template v-slot:cell(created_by)="row">
            <b-radio
              v-model="row.item.status_object.id"
              value="0"
              @change.native="changeStatus(row.item)"
              :disabled="!isScoreEditable"
            />
          </template>
          <template v-slot:cell(is_enable)="row">
            <b-radio
              v-model="row.item.status_object.id"
              value="1"
              @change.native="changeStatus(row.item)"
              :disabled="!isScoreEditable"
            />
          </template>
          <template v-slot:cell(created_at)="row">
            <b-radio
              v-model="row.item.status_object.id"
              value="2"
              @change.native="changeStatus(row.item)"
              :disabled="!isScoreEditable"
            />
          </template>
          <template v-slot:row-details="row">
            <LoadingSpinner
              :loading="includes(row.item.id, indicatorLoading)"
            />
            <table
              v-if="!includes(row.item.id, indicatorLoading)"
              class="table b-table"
            >
              <!-- temporary hidden thead of sub table with class d-none -->
              <thead role="rowgroup" class="d-none">
                <th>
                  <!-- temporary hidden this button with class d-none -->
                  <b-button
                    v-if="row.item.status_object.id >= 1"
                    :disabled="!isEditable || !isScoreEditable"
                    variant="primary"
                    size="sm"
                    @click="addEvidence(row.item)"
                    class="d-none"
                  >
                    <i class="fa fa-plus" aria-hidden="true" />
                  </b-button>
                </th>
                <th v-text="$lang.evidence_second_person" />
                <th v-text="$lang.sample_evidence" />
                <th v-text="$lang.search.operation" />
              </thead>

              <tbody role="rowgroup" v-if="row.item.evidences">
                <tr
                  role="row"
                  v-for="(evidence, index) in row.item.evidences"
                  :key="index"
                >
                  <td
                    style="width: 5%"
                    role="cell"
                    :style="changeColorRow(evidence)"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <span>
                        <!-- <span
                          class="text-info"
                          v-b-tooltip.hover
                          :title="'در صورت انتخاب گزینه ی عدم امکان احراز و احراز نشده برای نشانگر، امکان تغییر وجود ندارد'"
                          v-if="
                            pathOr(
                              null,
                              ['item', 'status_object', 'id'],
                              row
                            ) <= 0
                          "
                        >
                          <mdicon
                            name="information"
                            size="24"
                            class="cursor_pointer"
                          />
                        </span> 
                        else bottom code show
                        -->
                        <b-checkbox
                          v-model="evidence.checked"
                          :checked="evidence.checked"
                          :disabled="!isEditable"
                          @change.native="clickEvidence(row.item, evidence)"
                        />
                      </span>
                      <span
                        v-if="!!pathOr(null, ['evidence_data_log_count'], evidence)"
                        class="text-danger mx"
                        v-b-tooltip.hover
                        :title="'برای این مصداق خطایی ثبت شده است'"
                      >
                        <mdicon name="alert" size="20" />
                      </span>
                      <!-- <b-button
                        v-if="
                          pathOr(0, ['evidence_data_log_count'], evidence) > 1
                        "
                        variant="info"
                        size="sm"
                        class="position-relative"
                        v-b-tooltip.hover
                        :title="'این مصداق دارای بیش از 1 ردیف داده برای شاهد رفتاری می باشد'"
                        @click="showEvidenceHistoryLogModal(evidence)"
                      >
                        <span>
                          <b-badge
                            class="position-absolute top_left"
                            variant="danger"
                            pill
                            v-text="
                              pathOr(0, ['evidence_data_log_count'], evidence)
                            "
                          />
                          <mdicon name="list-status" size="20" />
                        </span>
                      </b-button> -->
                    </div>
                  </td>
                  <td
                    style="width: 45%"
                    v-if="evidence.evidence"
                    :style="changeColorRow(evidence)"
                    role="cell"
                    @click="editEvidence(row.item, evidence)"
                    v-b-tooltip.hover
                    title="برای ویرایش کلیک کنید"
                    class="cursor_pointer"
                  >
                    <span class="text-success mr-2">
                      <mdicon name="file-document-edit" />
                    </span>
                    <span v-text="evidence.evidence" />
                  </td>
                  <td
                    class="cursor_pointer w-100 h-100 d-flex align-items-center justify-content-start"
                    role="cell"
                  >
                    <span
                      v-if="evidence.sample"
                      @click="editEvidence(row.item, evidence)"
                      v-b-tooltip.hover
                      title="برای ویرایش کلیک کنید"
                    >
                      <span class="text-success mr-2">
                        <mdicon name="file-document-edit" />
                      </span>
                      <span v-text="evidence.sample" />
                    </span>
                  </td>
                  <td
                    v-if="
                      pathOr(null, ['evidence_data_id'], evidence) &&
                      includes(userExecutiveRoleId, [2, 3])
                    "
                    style="width: 5%"
                    class="text-center"
                  >
                    <b-button
                      size="sm"
                      variant="danger"
                      @click="showRemoveEvidenceConfirm(row.item, evidence)"
                    >
                      <mdicon name="trash-can-outline" size="20" />
                    </b-button>
                  </td>
                  <!-- temporary hidden td with set comment -->
                  <!-- <td>
                    <b-button
                      v-if="evidence.show_edit"
                      @click="editEvidence(row.item, evidence)"
                      variant="outline-primary"
                      size="sm"
                      class="mx-1"
                    >
                      <i class="fa fa-edit fa-lg"></i>
                    </b-button>
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      class="mx-1"
                      @click="like(row.item, evidence)"
                    >
                      <i
                        class="fa fa-thumbs-up fa-lg cursor-pointer"
                        :class="{ choosed: evidence.like === 1 }"
                      ></i>
                    </b-button>
                    <b-button
                      variant="outline-danger"
                      size="sm"
                      class="mx-1"
                      @click="disLike(row.item, evidence)"
                    >
                      <i
                        class="fa fa-thumbs-down fa-lg cursor-pointer"
                        :class="{ choosed: evidence.like === -1 }"
                      ></i>
                    </b-button>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </template>
        </b-table>
        <div v-else>
          <h5 class="text-center border p-2">{{ $lang.data_not_exist }}</h5>
        </div>
      </div>
      <b-modal
        no-close-on-backdrop
        variant="primary"
        header-bg-variant="primary"
        content-class="border-primary"
        v-model="view_add_evidence"
        size="lg"
        ok-only
        hide-footer
        hide-header
      >
        <EvidenceForm
          :isScoreEditable="isScoreEditable"
          :isEditable="isEditable"
          :userExecutiveRoleId="userExecutiveRoleId"
          :mode="mode"
          :isdisabled="isDisabled"
          :item="selected_evidence"
          @submit="submitEvidence"
          @cancel="cancelEvidance"
        />
      </b-modal>
      <b-modal
        no-close-on-backdrop
        variant="primary"
        header-bg-variant="primary"
        content-class="border-primary"
        v-model="view_edit_evidence"
        :size="showEvidenceHistoryLog ? 'xl' : 'lg'"
        ok-only
        hide-footer
        hide-header
      >
        <EvidenceScoreForm
          :isEditable="isEditable"
          :userExecutiveRoleId="userExecutiveRoleId"
          :mode="mode"
          :item="selected_evidence"
          @setSampleField="setSampleField"
          @submit="submitEvidence"
          @cancel="cancelEvidenceForm"
          @refresh="fetchData"
        />
        <b-row
          v-if="!includes(userExecutiveRoleId, [2])"
          class="my-3 p-2 bg-light rounded"
          align-v="center"
          align-h="between"
        >
          <b-col cols="" md="" v-text="$lang.showEvidenceHistoryLogTitle" />
          <b-col cols="auto" md="auto">
            <b-button
              variant="primary"
              @click="showEvidenceHistoryLog = !showEvidenceHistoryLog"
            >
              <span
                v-text="showEvidenceHistoryLog ? $lang.hidden : $lang.show"
              />
              <mdicon v-if="showEvidenceHistoryLog" name="chevron-up" />
              <mdicon v-else name="chevron-down" />
            </b-button>
          </b-col>
        </b-row>
        <Search
          v-if="showEvidenceHistoryLog"
          :url="evidenceHistoryLogUrl"
          :allowFields="$lang.evidenceHistoryLogFields"
          :hiddenFields="[]"
          :title="$lang.evidenceHistoryLogTitle"
          :allowCollapse="false"
          :visibleSearch="false"
          :visibleSettings="false"
          :visibleExport="false"
          :visibleFilters="false"
          :visibleViewCount="false"
          :visibleAdd="false"
          :allowEdit="false"
          :allowOperate="false"
        />
      </b-modal>
      <Confirm
        v-model="removeEvidenceConfirm"
        :title="$lang.remove"
        :description="removeEvidenceConfirmDescription"
        dynamicClass=""
        :loading="removeEvidenceConfirmLoading"
        :loadingSpinnerText="$lang.removing_data"
        :preventDefault="true"
        :cancel-title="$lang.no"
        :ok-title="$lang.yes"
        @cancel="cancelRemoveEvidenceConfirm"
        @ok="removeEvidence"
      />
    </div>
  </div>
</template>

<script>
import EvidenceForm from "@/modules/kanoon/views/forms/evidenceForm";
import EvidenceScoreForm from "@/modules/kanoon/views/forms/evidenceScoreForm";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import Search from "@/components/base/search";
import Confirm from "@/components/base/confirm";
import { pathOr, includes } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "marking-competency-indicators",
  inject: [
    "centerExecuteCompetencyIndicatorsRepository",
    "centerExecuteCompetencyIndicatorEvidencesRepository",
    "centerExecuteCompetencyIndicatorEvidenceLikeRepository",
  ],
  components: {
    EvidenceForm,
    EvidenceScoreForm,
    LoadingSpinner,
    Search,
    Confirm,
  },
  props: {
    case_id: {
      type: [String, Number],
      default: null,
    },
    center_execute_id: {
      type: [String, Number],
      default: null,
    },
    competency: {
      type: Object,
      default: null,
    },
    isScoreEditable: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    userExecutiveRoleId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      isDisabled: false,
      indicators: [],
      fields: ["id", "exercise", "candidate", "indicator"],
      isOverlay: false,
      indicatorLoading: [],
      view_add_evidence: false,
      selected_indicator: null,
      mode: "add",
      selected_evidence: null,
      view_edit_evidence: false,
      rowItemSelected: {},
      allowFields: this.$lang.markingCompentencyIndicator,
      competency_description: null,
      radiosTableLoading: false,
      showEvidenceHistoryLog: false,
      evidenceHistoryLogUrl: null,
      sampleField: null,
      removeEvidenceConfirm: false,
      removeEvidenceConfirmLoading: false,
      removingIndicatorItem: null,
      removingEvidenceItem: null,
    };
  },
  watch: {
    competency() {
      this.fetchData();
    },
  },
  computed: {
    removeEvidenceConfirmDescription() {
      return `با انجام حذف متن شاهد رفتاری و خطا و انتخاب مصداق پاک خواهد شد.
      <br />
      <br />
      <strong>${this.$lang.are_you_sure_delete}</strong>
    `;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    changeColorRow(evidence) {
      const condition = pathOr(null, ["status", "id"], evidence) === 2;
      if (condition) {
        return `backgroundColor:#f7ffab`;
      } else {
        return `backgroundColor:#10ff003d`;
      }
    },
    async cancelEvidenceForm() {
      this.view_add_evidence = false;
      this.view_edit_evidence = false;

      this.selected_indicator = null;
      this.selected_evidence = null;
    },
    cancelEvidance() {
      this.view_add_evidence = false;
      this.view_edit_evidence = false;
      this.selected_indicator = null;
      this.selected_evidence = null;
    },
    editEvidence(indicator, evidence) {
      if (!evidence.checked) {
        return this.$notify.warning(
          "با زدن تیک، مصداق مورد نظر را ابتدا انتخاب و سپس اقدام به درج شاهد رفتاری نمايید"
        );
      }
      this.mode = "edit";
      this.selected_indicator = indicator;
      this.selected_evidence = evidence;
      this.view_edit_evidence = true;
      this.showEvidenceHistoryLogModal(evidence);
    },
    async postEvidence(item) {
      this.isDisabled = true;
      try {
        const response =
          await this.centerExecuteCompetencyIndicatorEvidencesRepository.create(
            this.center_execute_id,
            this.case_id,
            this.competency.id,
            this.selected_indicator.indicator_object.id,
            item
          );
        this.$notify.success(response.data.message);
        this.getFinalEvidence();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isDisabled = false;
      }
    },
    getFinalEvidence() {
      this.$emit("getFinalEvidance");
    },
    async putEvidence(item) {
      this.isDisabled = true;
      try {
        const response =
          await this.centerExecuteCompetencyIndicatorEvidencesRepository.edit(
            this.center_execute_id,
            this.case_id,
            this.competency.id,
            this.selected_indicator.indicator_object.id,
            this.selected_evidence.id,
            item
          );
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isDisabled = false;
      }
    },
    like(indicator, evidence) {
      this.patchEvidenceLike(indicator, evidence, "like");
    },
    disLike(indicator, evidence) {
      this.patchEvidenceLike(indicator, evidence, "dislike");
    },
    setSampleField(value) {
      this.sampleField = value;
    },
    async patchEvidenceLike(indicator, evidence, type) {
      this.handleIndicatorLoading(indicator.id, true);
      try {
        const response =
          await this.centerExecuteCompetencyIndicatorEvidenceLikeRepository.edit(
            this.center_execute_id,
            this.case_id,
            this.competency.id,
            indicator.indicator_object.id,
            evidence.id,
            type
          );
        this.$notify.success(response.data.message);
        await this.refreshEvidence(indicator);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.handleIndicatorLoading(indicator.id, false);
      }
    },
    async submitEvidence(item) {
      try {
        if (this.mode === "add") {
          await this.postEvidence(item);
          this.rowItemSelected.evidence_count += 1;
        } else if (this.mode == "edit") {
          await this.putEvidence(item);
        }
        this.view_add_evidence = false;
        this.view_edit_evidence = false;
        await this.refreshEvidence(this.selected_indicator);
        this.selected_indicator = null;
        this.selected_evidence = null;
      } catch (error) {
        this.$generateError(error);
      }
    },
    async addEvidence(item) {
      this.mode = "add";
      this.selected_indicator = item;
      this.view_add_evidence = true;
    },
    async refreshEvidence(item, getFinalEvidence = true) {
      try {
        this.handleIndicatorLoading(item.id, true);
        const response = await this.getEvidences(item.indicator_object);
        this.indicators.find((x) => x.id === item.id).evidences = response;
        getFinalEvidence && this.getFinalEvidence();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.handleIndicatorLoading(item.id, false);
      }
    },
    extractValue(item, v) {
      if (item[v] && typeof item[v] === "object") {
        if ("jalali" in item[v]) {
          return item[v].jalali;
        } else if ("caption" in item[v]) {
          return item[v]["caption"];
        } else if ("name" in item[v]) {
          return item[v]["name"];
        } else if ("view_label" in item[v]) {
          return item[v].view_label ? item[v].view_label : "";
        }
      } else {
        return item[v];
      }
    },
    async fetchData() {
      try {
        this.isOverlay = true;

        let params = {
          order_by: "value:desc",
        };
        let res = await this.centerExecuteCompetencyIndicatorsRepository.list(
          this.center_execute_id,
          this.case_id,
          this.competency.id,
          params
        );
        let data = res.data.data.indicators;

        if (data && data.length > 0) {
          this.fields = Object.keys(this.allowFields).map((item) => {
            return {
              label: this.allowFields[item],
              key: item,
              sortable: false,
            };
          });

          data.map((item) => {
            Object.keys(item).map((v) => {
              // برای نگهداری دیتای قبلی
              if (typeof item[v] === "object") {
                item[v.concat("_object")] = item[v];
              }
              if (item[v] && Array.isArray(item[v])) {
                item[v] = item[v]
                  .map((value, idx) => {
                    return this.extractValue(item[v], idx);
                  })
                  .join("، ");
              } else {
                item[v] = this.extractValue(item, v);
              }
            });
            return item;
          });
        }
        const dataArr = pathOr([], ["data", "data"], res);
        this.indicators = pathOr([], ["indicators"], dataArr).map((ind) => {
          ind.collapse_evidence = false;
          if (includes(ind.status.id, [1, 2])) {
            ind.show_evidece = true;
          } else {
            ind.show_evidece = false;
          }
          ind.evidences = [];
          ind.has_seen_evidence = false;
          return ind;
        });
        this.competency_description = pathOr(
          [],
          ["competency", "description"],
          dataArr
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isOverlay = false;
      }
    },
    async getEvidences(indicator) {
      let params = {
        order_by: "id:desc",
      };
      try {
        let res =
          await this.centerExecuteCompetencyIndicatorEvidencesRepository.list(
            this.center_execute_id,
            this.case_id,
            this.competency.id,
            indicator.id,
            params
          );

        indicator.evidences = res.data.data.map((x) => {
          x.show_edit = x.selected;
          x.checked = x.selected;

          x.like = x.statistic ? x.statistic.like : null;

          return x;
        });
        return res.data.data;
      } catch (error) {
        this.$generateError(error);
        return false;
      }
    },
    async showIndicatorEvidence(row) {
      this.rowItemSelected = row.item;
      row.toggleDetails();
      if (!row.item.collapse_evidence) {
        await this.refreshEvidence(row.item, false);
        let checked = this.indicators
          .find((x) => x.id == row.item.id)
          .evidences.find((x) => x.checked);
        row.item.has_seen_evidence = checked ? true : false;
      }
      row.item.collapse_evidence = !row.item.collapse_evidence;
    },
    async patchEvidence(item) {
      try {
        const payload = {
          status: item.checked,
        };
        const response =
          await this.centerExecuteCompetencyIndicatorEvidencesRepository.edit(
            this.center_execute_id,
            this.case_id,
            this.competency.id,
            item.indicator.id,
            payload
          );
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    async clickEvidence(indicator, evidence, hardChecked = null) {
      try {
        this.selected_indicator = { ...indicator };
        this.selected_evidence = { ...evidence };
        const payload = {
          status: evidence.checked ? 1 : 0,
        };
        if (hardChecked !== null) {
          payload.status = hardChecked;
        }
        this.handleIndicatorLoading(indicator.id, true);
        await this.putEvidence(payload);
        this.handleIndicatorLoading(indicator.id, false);

        this.handleChecked(indicator, evidence, hardChecked);
      } catch (error) {
        this.$generateError(error);
      }
    },
    async handleChecked(indicator, evidence, hardChecked = null) {
      const evidenceChecked =
        hardChecked !== null ? hardChecked : evidence.checked;
      evidence.show_edit =
        hardChecked !== null ? !!hardChecked : !!evidenceChecked;
      if (evidenceChecked) {
        this.editEvidence(indicator, evidence);
      } else {
        await this.refreshEvidence(this.selected_indicator);
      }
      const indicatorChecked = this.indicators
        .find((x) => x.id == indicator.id)
        .evidences.find((x) => x.checked);
      indicator.has_seen_evidence = !!indicatorChecked;
    },
    async patchIndicator(item, startLoading = true) {
      try {
        this.radiosTableLoading = startLoading;
        let payload = {
          status: parseInt(
            this.indicators.find((x) => x.id == item.id).status_object.id
          ),
        };
        await this.centerExecuteCompetencyIndicatorsRepository.edit(
          this.center_execute_id,
          this.case_id,
          this.competency.id,
          item.indicator_object.id,
          payload
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.radiosTableLoading = false;
      }
    },
    async changeStatus(item) {
      if (includes(+item.status_object.id, [1, 2])) {
        item.show_evidece = true;
      } else {
        item.show_evidece = false;
        item.collapse_evidence = false;
      }
      this.handleIndicatorLoading(item.id, true);
      await this.patchIndicator(item, false);
      this.handleIndicatorLoading(item.id, false);
      this.getFinalEvidence();
    },
    async showEvidenceHistoryLogModal(evidence) {
      const id = pathOr(null, ["evidence_data_id"], evidence);
      if (!id) {
        this.evidenceHistoryLogUrl = null;
        return;
      }
      this.evidenceHistoryLogUrl = generateApiUrl(
        ["kanoon", "evidence_history_log"],
        [id]
      );
    },
    handleIndicatorLoading(id, state) {
      if (state) {
        this.indicatorLoading.push(id);
      } else {
        this.indicatorLoading = this.indicatorLoading.filter((x) => x != id);
      }
    },
    cancelRemoveEvidenceConfirm() {
      this.removingIndicatorItem = null;
      this.removingEvidenceItem = null;
      this.removeEvidenceConfirm = false;
    },
    showRemoveEvidenceConfirm(indicator, evidence) {
      this.removingIndicatorItem = indicator;
      this.removingEvidenceItem = evidence;
      this.removeEvidenceConfirm = true;
    },
    async removeEvidence() {
      const indicatorId = pathOr(null, ["id"], this.removingIndicatorItem);
      const evidenceDataId = pathOr(
        null,
        ["evidence_data_id"],
        this.removingEvidenceItem
      );
      try {
        this.removeEvidenceConfirmLoading = true;
        this.handleIndicatorLoading(indicatorId, true);
        const url = generateApiUrl(
          ["kanoon", "evidence_data_id"],
          [evidenceDataId]
        );
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.refreshEvidence(this.removingIndicatorItem, true);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.cancelRemoveEvidenceConfirm();
        this.handleIndicatorLoading(indicatorId, false);
        this.removeEvidenceConfirmLoading = false;
      }
    },
    generateIndicatorCode(item) {
      const code = pathOr(null, ["indicator_object", "code"], item);
      return code ? `(${code})` : "";
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.top_left {
  top: -8px;
  left: -8px;
}
.table th,
.table td {
  vertical-align: top !important;
  outline: 0;
}
.bade-main {
  position: absolute !important;
  top: -7px !important;
  left: -7px !important;
  width: 15px !important;
  color: #3bc90f3d;
}
.choosed {
  color: red;
}
</style>
